export const label = (d = false) => {
  return `<!DOCTYPE html>
    <html>
    
    <head>
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>ใบปะหน้า สติ๊กเกอร์ 100x75</title>
        <link rel="preconnect" href="https://fonts.googleapis.com/">
        <link rel="preconnect" href="https://fonts.gstatic.com/" crossorigin="">
        <style>
            body {
                counter-reset: page;
                font-family: 'Sarabun', sans-serif;
                padding: 0;
                margin: auto;
                width: 100mm;
            }
    
            div {
                overflow: hidden;
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
            }
    
            .label {
                display: flex;
                ;
                position: relative;
                width: 100mm;
                height: 75mm;
                text-align: center;
                overflow: hidden;
                margin: 0 auto;
                border: 0;
            }
    
            .page-break {
                clear: both;
                display: block;
                page-break-after: always;
            }
    
            img {
                image-rendering: pixelated;
            }
    
            @media print {
                @page {
                    size: 100mm 75mm portrait;
                    margin: 0;
                    padding: 0;
                }
            }
        </style>
    </head>
    <body>
    <div class="label">
        <div style="position:absolute;left:9px;top:110px;width:360px;height:55px;border:1px solid rgb(0,0,0);;">&nbsp;
        </div>
        <div style="position:absolute;left:9px;top:164px;width:360px;height:54px;border:1px solid rgb(0,0,0);;">&nbsp;
        </div>
        <div
            style="white-space: nowrap;overflow: hidden;;;position:absolute;transform: matrix(1,0,0,1,12,111);;width:217px;height:14px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;font-size:10px;line-height:normal;;;color:rgb(0,0,0);">
            ผู้ส่ง&nbsp;${d.sender_name}</div>
        <div
            style=";;position:absolute;transform: matrix(1,0,0,1,235,111);;width:130px;height:14px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;font-size:10px;line-height:normal;;;color:rgb(0,0,0);">
            โทร.&nbsp;${d.sender_tel}</div>
        <div
            style=";;position:absolute;transform: matrix(1,0,0,1,12,125);;width:354px;height:27px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;font-size:10px;line-height:normal;;;color:rgb(0,0,0);">
            ${d.sender_address}</div>
        <div
            style=";;position:absolute;transform: matrix(1,0,0,1,12,152);;width:176px;height:12px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;font-size:10px;line-height:normal;;;color:rgb(0,0,0);">
            ${d.sender_postcode}</div>
        <div
            style=";;position:absolute;transform: matrix(1,0,0,1,257,165);;width:109px;height:14px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;font-size:12px;font-weight:bold;line-height:normal;;;color:rgb(0,0,0);">
            โทร.&nbsp;${d.re_tel}</div>
        <div
            style="white-space: nowrap;overflow: hidden;;;position:absolute;transform: matrix(1,0,0,1,12,165);;width:218px;height:14px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;font-size:10px;font-weight:bold;line-height:normal;;;color:rgb(0,0,0);">
            ผู้รับ&nbsp;${d.re_name}</div>
        <div
            style=";;position:absolute;transform: matrix(1,0,0,1,12,179);;width:354px;height:27px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;font-size:10px;line-height:normal;;;color:rgb(0,0,0);">
            ${d.re_address}</div>
        <div
            style=";;position:absolute;transform: matrix(1,0,0,1,12,205);;width:176px;height:12px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;font-size:10px;line-height:normal;;;color:rgb(0,0,0);">
            ${d.re_postcode}</div>
        <div style="position:absolute;left:9px;top:244px;width:360px;height:30px;border:1px solid rgb(0,0,0);;">&nbsp;
        </div>
        <div
            style=";;position:absolute;transform: matrix(1,0,0,1,12,246);;width:354px;height:27px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;font-size:10px;line-height:normal;;;color:rgb(0,0,0);">
        </div>
        <div
            style=";display: flex;align-content: center;justify-content: space-evenly;align-items: center;;position:absolute;transform:matrix(1,0,0,1,16,47);;width:346px;height:30px;border:0px solid rgb(0,0,0);text-align:center;vertical-align:middle;font-size:25px;line-height:normal;;;color:rgb(0,0,0);">
            ${d.tracking_code}</div>
        <div style="position:absolute;left:205px;top:217px;width:164px;height:28px;border:1px solid rgb(0,0,0);;">&nbsp;
        </div>
        <div style="position:absolute;left:157px;top:217px;width:49px;height:28px;border:1px solid rgb(0,0,0);;">&nbsp;
        </div>
        <div style="position:absolute;left:9px;top:217px;width:57px;height:28px;border:1px solid rgb(0,0,0);;">&nbsp;
        </div>
        <div style="position:absolute;left:65px;top:217px;width:46px;height:28px;border:1px solid rgb(0,0,0);;">&nbsp;
        </div>
        <div style="position:absolute;left:110px;top:217px;width:48px;height:28px;border:1px solid rgb(0,0,0);;">&nbsp;
        </div>
        <div
            style="position:absolute;transform: matrix(1,0,0,1,18,218);;width:46px;height:13px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;line-height:normal;font-size:10px;;;color:rgb(0,0,0);;line-height:normal;">
            น้ำหนัก</div>
        <div
            style="position:absolute;transform: matrix(1,0,0,1,70,218);;width:40px;height:12px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;line-height:normal;font-size:10px;;;color:rgb(0,0,0);;line-height:normal;">
            กว้าง</div>
        <div
            style="position:absolute;transform: matrix(1,0,0,1,116,218);;width:40px;height:14px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;line-height:normal;font-size:10px;;;color:rgb(0,0,0);;line-height:normal;">
            ยาว</div>
        <div
            style="position:absolute;transform: matrix(1,0,0,1,165,218);;width:40px;height:15px;border:0px solid rgb(0,0,0);text-align:left;vertical-align:middle;line-height:normal;font-size:10px;;;color:rgb(0,0,0);;line-height:normal;">
            สูง</div>
        <div
            style=";display: flex;align-content: center;justify-content: space-evenly;align-items: center;;position:absolute;transform: matrix(1,0,0,1,11,231);;width:54px;height:13px;border:0px solid rgb(0,0,0);text-align:center;vertical-align:middle;font-size:10px;line-height:normal;;;color:rgb(0,0,0);">
            ${d.weight} กรัม</div>
        <div
            style=";display: flex;align-content: center;justify-content: space-evenly;align-items: center;;position:absolute;transform: matrix(1,0,0,1,66,230);;width:43px;height:14px;border:0px solid rgb(0,0,0);text-align:center;vertical-align:middle;font-size:10px;line-height:normal;;;color:rgb(0,0,0);">
        </div>
        <div
            style=";display: flex;align-content: center;justify-content: space-evenly;align-items: center;;position:absolute;transform: matrix(1,0,0,1,111,232);;width:48px;height:12px;border:0px solid rgb(0,0,0);text-align:center;vertical-align:middle;font-size:10px;line-height:normal;;;color:rgb(0,0,0);">
        </div>
        <div
            style=";display: flex;align-content: center;justify-content: space-evenly;align-items: center;;position:absolute;transform: matrix(1,0,0,1,158,233);;width:47px;height:11px;border:0px solid rgb(0,0,0);text-align:center;vertical-align:middle;font-size:10px;line-height:normal;;;color:rgb(0,0,0);">
        </div>
    </div>
    <div class="page-break"></div>
    </body>
    </html>`;
};
